const COOKIE_CONSENT_KEY = 'trackactive_cookie_consent'
const COOKIE_CONSENT_DAYS = 365

const defaultPreferences = () => ({
  necessary: true,
  functional: false,
  performance: false,
  analytics: false,
  advertisement: false,
  others: false,
  acceptedAll: false,
})

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
}

const readPreferences = () => {
  try {
    const raw = getCookie(COOKIE_CONSENT_KEY)
    if (!raw) return null
    return { ...defaultPreferences(), ...JSON.parse(raw) }
  } catch (error) {
    return null
  }
}

const writePreferences = (preferences) => {
  setCookie(COOKIE_CONSENT_KEY, JSON.stringify(preferences), COOKIE_CONSENT_DAYS)
}

const applyPreferencesToForm = (root, preferences) => {
  root.querySelectorAll('.js-cookie-preference').forEach((input) => {
    const category = input.dataset.category
    input.checked = Boolean(preferences[category])
  })
}

const collectPreferencesFromForm = (root, acceptedAll = false) => {
  const preferences = defaultPreferences()
  preferences.acceptedAll = acceptedAll

  root.querySelectorAll('.js-cookie-preference').forEach((input) => {
    preferences[input.dataset.category] = acceptedAll ? true : input.checked
  })

  if (acceptedAll) {
    preferences.functional = true
    preferences.performance = true
    preferences.analytics = true
    preferences.advertisement = true
    preferences.others = true
  }

  return preferences
}

const initializeCookieConsent = () => {
  const banner = document.querySelector('.js-cookie-consent')
  const modal = document.querySelector('.js-cookie-settings-modal')
  if (!banner || !modal || banner.dataset.initialized) return

  const existingPreferences = readPreferences()
  const overviewText = modal.querySelector('.js-cookie-overview-text')
  const overviewToggle = modal.querySelector('.js-cookie-overview-toggle')

  const hideBanner = () => {
    banner.hidden = true
  }

  const showBanner = () => {
    banner.hidden = false
  }

  const openModal = () => {
    const preferences = readPreferences() || defaultPreferences()
    applyPreferencesToForm(modal, preferences)
    modal.hidden = false
    document.body.classList.add('cookie-consent-modal-open')
  }

  const closeModal = () => {
    modal.hidden = true
    document.body.classList.remove('cookie-consent-modal-open')
  }

  const savePreferences = (preferences) => {
    writePreferences(preferences)
    applyPreferencesToForm(modal, preferences)
    closeModal()
    hideBanner()
  }

  banner.querySelectorAll('.js-cookie-settings').forEach((button) => {
    button.addEventListener('click', openModal)
  })

  banner.querySelectorAll('.js-cookie-accept-all').forEach((button) => {
    button.addEventListener('click', () => {
      savePreferences(collectPreferencesFromForm(modal, true))
    })
  })

  modal.querySelectorAll('.js-cookie-settings-close').forEach((element) => {
    element.addEventListener('click', closeModal)
  })

  modal.querySelectorAll('.js-cookie-save').forEach((button) => {
    button.addEventListener('click', () => {
      savePreferences(collectPreferencesFromForm(modal, false))
    })
  })

  modal.querySelectorAll('.js-cookie-category-toggle').forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.closest('.cookie-consent-modal__category')
      const content = category?.querySelector('.cookie-consent-modal__category-content')
      if (!content) return

      const isOpen = button.getAttribute('aria-expanded') === 'true'
      button.setAttribute('aria-expanded', String(!isOpen))
      content.hidden = isOpen
    })
  })

  if (overviewToggle && overviewText) {
    overviewToggle.addEventListener('click', () => {
      const expanded = overviewText.classList.toggle('is-expanded')
      overviewToggle.textContent = expanded
        ? overviewToggle.dataset.readless
        : overviewToggle.dataset.readmore
    })
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal()
  })

  if (existingPreferences) {
    hideBanner()
  } else {
    showBanner()
  }

  banner.dataset.initialized = 'true'
}

document.addEventListener('DOMContentLoaded', initializeCookieConsent)
document.addEventListener('turbolinks:load', initializeCookieConsent)
